export default __webpack_public_path__ + "static/item_15-b841210989a57df4dbcb914e52acefa5.jpg";